function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// @ts-nocheck
import React, { Component } from 'react';
import { Animated, Dimensions, PanResponder, Platform, StatusBar, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Modal } from "../../native";
const WINDOW_HEIGHT = Dimensions.get('window').height;
const WINDOW_WIDTH = Dimensions.get('window').width;
const DRAG_DISMISS_THRESHOLD = 150;
const STATUS_BAR_OFFSET = Platform.OS === 'android' ? -25 : 0;
const isIOS = Platform.OS === 'ios';
const styles = StyleSheet.create({
  background: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: WINDOW_WIDTH,
    height: WINDOW_HEIGHT
  },
  open: {
    position: 'absolute',
    flex: 1,
    justifyContent: 'center',
    // Android pan handlers crash without this declaration:
    backgroundColor: 'transparent'
  },
  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: WINDOW_WIDTH,
    backgroundColor: 'transparent'
  },
  closeButton: {
    fontSize: 35,
    color: 'white',
    lineHeight: 40,
    width: 40,
    textAlign: 'center',
    shadowOffset: {
      width: 0,
      height: 0
    },
    shadowRadius: 1.5,
    shadowColor: 'black',
    shadowOpacity: 0.8
  }
});
export default class LightboxOverlay extends Component {
  // static propTypes = {
  //   origin: PropTypes.shape({
  //     x: PropTypes.number,
  //     y: PropTypes.number,
  //     width: PropTypes.number,
  //     height: PropTypes.number,
  //   }),
  //   springConfig: PropTypes.shape({
  //     tension: PropTypes.number,
  //     friction: PropTypes.number,
  //   }),
  //   backgroundColor: PropTypes.string,
  //   isOpen: PropTypes.bool,
  //   renderHeader: PropTypes.func,
  //   onOpen: PropTypes.func,
  //   onClose: PropTypes.func,
  //   willClose: PropTypes.func,
  //   swipeToDismiss: PropTypes.bool,
  // }
  constructor(props) {
    super(props);

    _defineProperty(this, "open", () => {
      if (isIOS) {
        StatusBar.setHidden(true, 'fade');
      }

      this.state.pan.setValue(0);
      this.setState({
        isAnimating: true,
        target: {
          x: 0,
          y: 0,
          opacity: 1
        }
      });
      Animated.spring(this.state.openVal, _objectSpread({
        toValue: 1
      }, this.props.springConfig)).start(() => {
        this.setState({
          isAnimating: false
        });
        this.props.didOpen();
      });
    });

    _defineProperty(this, "close", () => {
      this.props.willClose();

      if (isIOS) {
        StatusBar.setHidden(false, 'fade');
      }

      this.setState({
        isAnimating: true
      });
      Animated.spring(this.state.openVal, _objectSpread({
        toValue: 0
      }, this.props.springConfig)).start(() => {
        this.setState({
          isAnimating: false
        });
        this.props.onClose();
      });
    });

    this.state = {
      isAnimating: false,
      isPanning: false,
      target: {
        x: 0,
        y: 0,
        opacity: 1
      },
      pan: new Animated.Value(0),
      openVal: new Animated.Value(0)
    };
    this._panResponder = PanResponder.create({
      // Ask to be the responder:
      onStartShouldSetPanResponder: (evt, gestureState) => !this.state.isAnimating,
      onStartShouldSetPanResponderCapture: (evt, gestureState) => !this.state.isAnimating,
      onMoveShouldSetPanResponder: (evt, gestureState) => !this.state.isAnimating,
      onMoveShouldSetPanResponderCapture: (evt, gestureState) => !this.state.isAnimating,
      onPanResponderGrant: (evt, gestureState) => {
        this.state.pan.setValue(0);
        this.setState({
          isPanning: true
        });
      },
      onPanResponderMove: Animated.event([null, {
        dy: this.state.pan
      }]),
      onPanResponderTerminationRequest: (evt, gestureState) => true,
      onPanResponderRelease: (evt, gestureState) => {
        if (Math.abs(gestureState.dy) > DRAG_DISMISS_THRESHOLD) {
          this.setState({
            isPanning: false,
            target: {
              y: gestureState.dy,
              x: gestureState.dx,
              opacity: 1 - Math.abs(gestureState.dy / WINDOW_HEIGHT)
            }
          });
          this.close();
        } else {
          Animated.spring(this.state.pan, _objectSpread({
            toValue: 0
          }, this.props.springConfig)).start(() => {
            this.setState({
              isPanning: false
            });
          });
        }
      }
    });
  }

  componentDidMount() {
    if (this.props.isOpen) {
      this.open();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen !== prevProps.isOpen && this.props.isOpen) {
      this.open();
    }
  }

  render() {
    const {
      isOpen,
      renderHeader,
      swipeToDismiss,
      origin,
      backgroundColor
    } = this.props;
    const {
      isPanning,
      isAnimating,
      openVal,
      target
    } = this.state;
    const lightboxOpacityStyle = {
      opacity: openVal.interpolate({
        inputRange: [0, 1],
        outputRange: [0, target.opacity]
      })
    };
    let handlers;

    if (swipeToDismiss) {
      handlers = this._panResponder.panHandlers;
    }

    let dragStyle;

    if (isPanning) {
      dragStyle = {
        top: this.state.pan
      };
      lightboxOpacityStyle.opacity = this.state.pan.interpolate({
        inputRange: [-WINDOW_HEIGHT, 0, WINDOW_HEIGHT],
        outputRange: [0, 1, 0]
      });
    }

    const openStyle = [styles.open, {
      left: openVal.interpolate({
        inputRange: [0, 1],
        outputRange: [origin.x, target.x]
      }),
      top: openVal.interpolate({
        inputRange: [0, 1],
        outputRange: [origin.y + STATUS_BAR_OFFSET, target.y + STATUS_BAR_OFFSET]
      }),
      width: openVal.interpolate({
        inputRange: [0, 1],
        outputRange: [origin.width, WINDOW_WIDTH]
      }),
      height: openVal.interpolate({
        inputRange: [0, 1],
        outputRange: [origin.height, WINDOW_HEIGHT]
      })
    }];
    const background = /*#__PURE__*/React.createElement(Animated.View, {
      style: [styles.background, {
        backgroundColor
      }, lightboxOpacityStyle]
    });
    const header = /*#__PURE__*/React.createElement(Animated.View, {
      style: [styles.header, lightboxOpacityStyle]
    }, renderHeader ? renderHeader(this.close) : /*#__PURE__*/React.createElement(TouchableOpacity, {
      onPress: this.close
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles.closeButton
    }, "\xD7")));
    const content = /*#__PURE__*/React.createElement(Animated.View, _extends({
      style: [openStyle, dragStyle]
    }, handlers), this.props.children);

    if (this.props.navigator) {
      return /*#__PURE__*/React.createElement(View, null, background, content, header);
    }

    return /*#__PURE__*/React.createElement(Modal, {
      visible: isOpen,
      onBackdropPress: () => this.close(),
      style: styles.background
    }, background, content, header);
  }

}

_defineProperty(LightboxOverlay, "defaultProps", {
  springConfig: {
    tension: 30,
    friction: 7
  },
  backgroundColor: 'black'
});